var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGbRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V100H100V0H0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20L100 80L0 20ZM100 20L0 80Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 20L0 80M0 20L100 80L0 20Z",
    stroke: "white",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20L100 80L0 20ZM100 20L0 80Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 20L0 80M0 20L100 80L0 20Z",
    stroke: "#C8102E",
    strokeWidth: 6.666
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 0V100V0ZM0 50H100Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 50H100M50 0V100V0Z",
    stroke: "white",
    strokeWidth: 16.666
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 0V100V0ZM0 50H100Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 50H100M50 0V100V0Z",
    stroke: "#C8102E",
    strokeWidth: 12
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGbRounded);
export default __webpack_public_path__ + "static/media/ic-gb-rounded.aea7d22bffea30802150c97e3d34e1eb.svg";
export { ForwardRef as ReactComponent };